module.exports = __webpack_public_path__ + "static/media/strong-authentication-icon.dc8612ee.svg";